import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { app } from '../firebase';

const db = getFirestore(app);

export const menuService = {
  /**
   * Fetch all available menu items
   * @returns {Promise<Array>} Array of menu items
   */
  async getMenuItems() {
    try {
      const menuSnapshot = await getDocs(collection(db, 'menu_items'));
      const menuItems = menuSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      // Sort by category and name for better organization
      return menuItems.sort((a, b) => {
        if (a.category !== b.category) {
          return a.category.localeCompare(b.category);
        }
        return a.name.localeCompare(b.name);
      });
    } catch (error) {
      console.error('Error fetching menu items:', error);
      throw new Error('Failed to fetch menu items');
    }
  },

  /**
   * Get menu items grouped by category
   * @returns {Promise<Object>} Menu items grouped by category
   */
  async getMenuItemsByCategory() {
    try {
      const menuItems = await this.getMenuItems();
      const grouped = {};
      
      menuItems.forEach(item => {
        if (!grouped[item.category]) {
          grouped[item.category] = [];
        }
        grouped[item.category].push(item);
      });
      
      return grouped;
    } catch (error) {
      console.error('Error grouping menu items:', error);
      throw new Error('Failed to group menu items');
    }
  },

  /**
   * Find a menu item by name
   * @param {string} name - Item name to search for
   * @returns {Promise<Object|null>} Menu item or null if not found
   */
  async findMenuItemByName(name) {
    try {
      const menuItems = await this.getMenuItems();
      return menuItems.find(item => 
        item.name.toLowerCase() === name.toLowerCase()
      ) || null;
    } catch (error) {
      console.error('Error finding menu item:', error);
      return null;
    }
  }
};

export default menuService;
